<ng-container *transloco="let t">
    <app-nav-tabs [useRouterOutlet]="true" [queryParamsHandling]="'preserve'">
        <app-nav-tab [title]="t('league.management.tabs.events')" [itemId]="1" [route]="LEAGUES_MANAGEMENT_EVENTS">
        </app-nav-tab>
        <app-nav-tab [title]="t('league.management.tabs.competitors')" [itemId]="2" [route]="LEAGUES_MANAGEMENT_COMPETITORS">
        </app-nav-tab>
        <app-nav-tab  [title]="t('league.management.tabs.results')" [itemId]="3" [route]="LEAGUES_MANAGEMENT_RESULTS">
        </app-nav-tab>
    </app-nav-tabs>
    <app-action-buttons-row [saveVisible]="false"/>
</ng-container>
